import type {WorkloadScore} from "../../4-scoring/performScoring.ts";
import type {Workload} from "../../3-workload-analysis/model/Workload.ts";
import type {WorkloadInput} from "../../3-workload-analysis/model/WorkloadInput.ts";
import {sortByExecutionCount} from "../utils/workloadSorting.ts";
import {ActiveWorkloadsTable} from "../components/ActiveWorkloadsTable.tsx";

/**
 * Section showing what workloads are actively running
 */
export function ActiveWorkloadsSection({
    workloadScores,
    getWorkloadInput
}: {
    workloadScores: WorkloadScore[]
    getWorkloadInput: (workload: Workload) => WorkloadInput | undefined
}) {
    const activeWorkloads = sortByExecutionCount(workloadScores)
    
    return (
        <section>
            <h3>What actually runs on my instance?</h3>
            <p>
                Often Matillion ETL instances contain old or testing versions of pipelines that are no longer run. 
                Best practice is to not migrate these so you start with a clean edge in DPC. These pipelines have 
                run in the last 31 days. We recommend starting with your most used pipelines to get the DPC benefits sooner.
            </p>
            <ActiveWorkloadsTable workloadScores={activeWorkloads} getWorkloadInput={getWorkloadInput} />
        </section>
    )
}
